import React, {useState} from 'react';
import {IObjectSelectProps} from '../ObjectSelect';
import {useTranslation} from 'react-i18next';
import {cnObjectSelect} from '../index';
import {ObjectSelectSelect} from '../Select/ObjectSelect-Select';
import {Modal} from '../../Modal';
import {AccessoryList, cnAccessoryList} from '../../../elements/AccessoryList/AccessoryList';
import {IClassNameProps, withBemMod} from '@bem-react/core';
import {OBJECT_SELECT_TYPE_HANDLE} from '../../../../constants';
import {IHandleData} from '../../../../../common-code/interfaces/materials/IHandleData';

const ObjectSelectHandle: React.FC<IObjectSelectProps<IHandleData>> =
    ({
         data,
         list,
         title,
         showObject,
         onSelectObject,
         onChangeDepth,
         className,
         facadeMaterials
     }) => {
        const {t} = useTranslation();
        const [showModal, setShowModal] = useState<boolean>(false);

        const emptyObjectData: IHandleData = {
            id: 'none',
            title: t('Не выбрано'),
            models: [],
        };
        const objectData: IHandleData = data && data.object ? data.object : emptyObjectData;

        return (
            <div className={cnObjectSelect({}, [className])}>
                <ObjectSelectSelect
                    className={cnObjectSelect('Select')}
                    image={showObject && objectData.image ? {
                        path: objectData.image,
                        label: objectData.title,
                        width: 60,
                        height: 60
                    } : undefined}
                    icon={!showObject || (!objectData.image) ? {
                        path: 'no-photo',
                        label: objectData.title,
                        width: 60,
                        height: 60
                    } : undefined}
                    title={title}
                    description={showObject ? objectData.title : t('Не выбрано') || undefined}
                    callBack={() => {
                        setShowModal(true);
                    }}
                />
                {showModal ?
                    <Modal
                        className={cnObjectSelect('Modal')}
                        visible={showModal}
                        callBack={setShowModal}
                        size={'full'}
                    >
                        {!list || !onSelectObject ?
                            <div className={cnObjectSelect('Error')}>{t('Загрузка данных')}...</div> :
                            <AccessoryList
                                className={cnObjectSelect(cnAccessoryList())}
                                listMaterialData={list}
                                materialData={objectData}
                                showObject={showObject}
                                onSelectObject={onSelectObject}
                                title={title}
                                onChangeDepth={onChangeDepth}
                                facadeMaterials={facadeMaterials}
                                setShowModal={setShowModal}
                            />
                        }
                    </Modal> : null
                }
            </div>
        );
    }

export const withObjectSelectHandle = withBemMod<IObjectSelectProps<IHandleData>, IClassNameProps>(
    cnObjectSelect(),
    {type: OBJECT_SELECT_TYPE_HANDLE},
    () => ObjectSelectHandle
);